import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import Cancel_Conformation from "./Cancel_Conformation_PopUp";
export default function CancelPop_Up({
  cancelPopUp,
  setCancelPopUp,
  setTrigger,
  trigger,
  propsData,
}) {
  console.log("Immediate props data to be seen here", propsData);
  const [selectedOption, setSelectedOption] = useState();
  const dispatch = useDispatch();

  const [inputData, setInputData] = useState({
    credit_note_amount: "",
    credit_note_reference_no: "",
    credit_note_issue_date: "",
    remarks_for_invoice_cancellation: "",
    payment_type: "",
  });

  const handleCheckboxChange = (value) => {
    setSelectedOption(value);
    if (value === "CANCEL") {
      setInputData({
        credit_note_amount: "",
        credit_note_reference_no: "",
        credit_note_issue_date: "",
        payment_type: "CANCEL_INVOICE",
      });
      return;
    } else {
      setInputData({
        remarks_for_invoice_cancellation: "",
        payment_type: "CREDIT_NOTE",
      });
    }
  };

  const [date, setDate] = useState();

  const [loading, setLoading] = useState(false);

  const handleInputFieldChange = (e) => {
    const { name, value } = e.target;
    setInputData({
      ...inputData,
      [name]: value,
    });
  };
  const token = localStorage.getItem("nodeToken");

  const [newPopUp, setNewPopUp] = useState(false);

  const onSubmit = async () => {
    if (inputData.payment_type === "CANCEL_INVOICE") {
      setNewPopUp(true);
      return;
    }
    setLoading(true);
    console.log("reqobj......", inputData);
    try {
      console.log("inputData....to be seen here..", inputData);
      if (inputData.credit_note_amount <= 0) {
        dispatch(
          setAppError({
            msg: "Credit Note amount should be greater then 0 ",
          })
        );
        return;
      }
      console.log(
        ".......propsData.invoice_amount",
        parseInt(propsData.credit_note_amount) + inputData.credit_note_amount,
        propsData.invoice_amount
      );
      if (
       ( parseInt(
          propsData.credit_note_amount === null
            ? 0
            : propsData.credit_note_amount
        ) +
          parseInt(inputData.credit_note_amount)) >
        parseInt(propsData.invoice_amount)
      ) {
        dispatch(
          setAppError({
            msg: "Credit Note amount exceeds.",
          })
        );
        setLoading(false);
        return;
      }
      const reqObject = {
        ...inputData,
        credit_note_amount:
          parseInt(
            propsData.credit_note_amount === null
              ? 0
              : propsData.credit_note_amount
          ) + parseInt(inputData.credit_note_amount),
        invoice_status:
          inputData.payment_type === "CREDIT_NOTE" ? "ACTIVE" : "INACTIVE",
      };
      const response = await nodeinstance.put(
        `/dashboard/visaSecurity/cancelflow/${propsData.id}`,
        reqObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setTrigger(!trigger);
        dispatch(
          setAppError({ msg: "Updated successfully.", color: "success" })
        );
        setCancelPopUp(false);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log("error to be capctured here....", error);
      dispatch(setAppError({ msg: "Unable to update" }));
    }
  };
  console.log("propsData TO BE PRINTED HERE....", propsData);
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          cancelPopUp ? "flex" : "hidden"
        }`}
      >
        {/* <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative"> */}
        <div className="max-w-lg w-full overflow-auto rounded-md bg-white/95 flex flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setCancelPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              REQUEST/INVOICE NO.
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              disabled
              value={propsData?.invoice_number}
            />
          </div>
          <div className="flex">
            <label className="mr-4">
              <input
                className="ml-2"
                type="checkbox"
                checked={selectedOption === "CREDIT NOTE"}
                onChange={() => handleCheckboxChange("CREDIT NOTE")}
              />
              <span className="ml-2">Submit Credit Note</span>
            </label>
            <label className="mr-4 ml-3">
              <input
                type="checkbox"
                checked={selectedOption === "CANCEL"}
                onChange={() => handleCheckboxChange("CANCEL")}
                disabled={parseInt(propsData.credit_note_amount) > 0}
              />
              <span className="ml-2">Cancel Invoice</span>
            </label>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              CREDIT NOTE AMOUNT
            </label>
            <input
              type="number"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              disabled={selectedOption === "CANCEL"}
              name="credit_note_amount"
              onChange={(e) => {
                handleInputFieldChange(e);
              }}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              CREDIT NOTE REFERENCE NUMBER
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              name="credit_note_reference_no"
              onChange={(e) => {
                handleInputFieldChange(e);
              }}
              disabled={selectedOption === "CANCEL"}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              CREDIT NOTE ISSUE DATE
            </label>
            <input
              type="Date"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              //   onChange={(e) => {
              //     setDate(e.target.value);
              //   }}
              name="credit_note_issue_date"
              onChange={(e) => {
                handleInputFieldChange(e);
              }}
              onKeyDown={(e) => e.preventDefault()}
              disabled={selectedOption === "CANCEL"}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              REMARKS FOR INVOICE CANCELLATION
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              disabled={selectedOption != "CANCEL"}
              name="remarks_for_invoice_cancellation"
              onChange={(e) => {
                handleInputFieldChange(e);
              }}
            />
          </div>
          <div className="flex gap-3 w-full justify-center" style={{ m: 2 }}>
            <button
              className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
              onClick={() => {
                onSubmit();
              }}
            >
              {" "}
              <p>Submit</p>
              {loading ? <CgSpinner className="animate-spin" /> : ""}
            </button>
          </div>
        </div>
      </div>
      {newPopUp ? (
        <Cancel_Conformation
          newPopUp={newPopUp}
          setNewPopUp={setNewPopUp}
          setCancelPopUp={setCancelPopUp}
          setTrigger={setTrigger}
          trigger={trigger}
          data={inputData}
          propsData={propsData}
        />
      ) : (
        ""
      )}
    </>
  );
}
